import { CardContent, Typography, Stack, Box } from "@mui/material";
import React from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import utilities from "../../utility/utilities";
import { StyledCard } from "../../assets/styled-components/StyledCard";

function WorkRequestStatus({ response }) {
  const recentMonths = utilities.getRecentSixMonths(); // Use utility to get recent 6 months

  const workRequestData = response?.workRequestOpenCompletedCounts || {};

  // Data for Open and Completed work requests
  const opened = [
    workRequestData?.wrMonthSixOpenCount || 0, // Past month
    workRequestData?.wrMonthFiveOpenCount || 0,
    workRequestData?.wrMonthFourOpenCount || 0,
    workRequestData?.wrMonthThreeOpenCount || 0,
    workRequestData?.wrMonthTwoOpenCount || 0,
    workRequestData?.wrMonthOneOpenCount || 0, // Current month
  ];

  const completed = [
    workRequestData?.wrMonthSixCompletedCount || 0, // Past month
    workRequestData?.wrMonthFiveCompletedCount || 0,
    workRequestData?.wrMonthFourCompletedCount || 0,
    workRequestData?.wrMonthThreeCompletedCount || 0,
    workRequestData?.wrMonthTwoCompletedCount || 0,
    workRequestData?.wrMonthOneCompletedCount || 0, // Current month
  ];

  const totalOpened = opened.reduce((acc, value) => acc + value, 0);
  const totalCompleted = completed.reduce((acc, value) => acc + value, 0);

  return (
    <StyledCard variant={"outlined"}>
      <CardContent>
        <Stack
          direction="row"
          spacing={1}
          flexWrap={"wrap"}
          useFlexGap
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color={"text.primary"}
          >
            Work Request Status
          </Typography>
        </Stack>

        <Box width={"100%"}>
          <BarChart
            height={300}
            series={[
              {
                data: opened,
                label: (location) => location === 'tooltip' ? 'Opened' : `Opened(${totalOpened})`,
                id: "open",
                stack: "total", // Stack the bars
                color: "#2e96ff", // Custom color for Opened
              },
              {
                data: completed,
                label: (location) => location === 'tooltip' ? 'Completed' : `Completed(${totalCompleted})`,
                id: "completed",
                stack: "total", // Stack the bars
                color: "#02b2af", // Custom color for Completed
              },
            ]}
            slotProps={{
              legend: {
                direction: "row",
                position: { vertical: "bottom", horizontal: "center" },
                padding: 0,
                itemMarkWidth: 15,
                itemMarkHeight: 15,
                markGap: 5,
                itemGap: 16,
                labelStyle: {
                  fontSize: 12,
                  color: "text.primary",
                  fontWeight: 400,
                },
              },
            }}
            xAxis={[
              {
                data: recentMonths.map((month) => month.label),
                scaleType: "band",
                categoryGapRatio: 0.7,
                tickLabelStyle: {
                  // Adjust label font size
                  fontSize: 11,
                  overflowWrap: "break-word",
                  whiteSpace: "nowrap", // Prevents text from breaking
                },
              },
            ]}
          />
        </Box>
      </CardContent>
    </StyledCard>
  );
}

export default WorkRequestStatus;
